import { useEffect } from 'react';

export function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const siblings = Array.from(entry.target.parentElement?.children || []);
            const index = siblings.indexOf(entry.target);
            const delay = (index % 3) * 80;
            setTimeout(() => {
              entry.target.classList.add('fs-visible');
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' },
    );

    document.querySelectorAll('.fs-reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}
